module.exports = __webpack_public_path__ + "img/notepad.62a2068d.svg";